module.exports = __webpack_public_path__ + "img/_88A4417_8_9Balanced.c81979f3.jpg";